import {useEffect, useState} from "react";
import {CreditCard, DollarSign, User} from "react-feather";
import {
    Badge,
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Label
} from "reactstrap";
import {
    getInfoReferral,
    getListBank,
    getMyBalance,
    getMyCard,
    requestWithdraws,
    saveMyCardInfo
} from "@store/actions/withdrawal";
import {useDispatch, useSelector} from "react-redux";
import alert from "@src/utility/Alert";
import AtomPageLoader from "@atoms/PageLoader";
import Select from "react-select";
import AtomReferralGenerate from "@src/views/referral/AtomReferralGenerate";

const Withdrawal = ({stepper, id, loadSection}) => {
    const dispatch = useDispatch();
    const {
        card, banks, balance, info
    } = useSelector((state) => state.withdrawal);
    const [isFetch, setIsFetch] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bankOptions, setBankOptions] = useState([]);


    const [accountName, setAccountName] = useState("");
    const [accountNumber, setAccountNumber] = useState(0);
    const [bankId, setBankId] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [withdrawalAmount, setWithdrawalAmount] = useState(0);

    useEffect(() => {
        (async () => {
            if(loadSection === id) {
                try {
                    setIsFetch(false);
                    setLoading(true);
                    await dispatch(getInfoReferral());
                    await dispatch(getListBank());
                    await dispatch(getMyCard());
                    await dispatch(getMyBalance());
                } catch (error) {
                    alert.error(error.message);
                } finally {
                    setLoading(false);
                    setIsFetch(true);
                }
            }
        })();
    }, [loadSection]);

    useEffect(() => {
        (async () => {
            if(banks.length > 0) {
                const banksOption = [];
                banks.forEach((bank) => {
                    banksOption.push({
                        value: bank.sid,
                        label: bank.name
                    })
                })
                setBankOptions(banksOption);
            }
        })();
    }, [banks]);

    useEffect(() => {
        (async () => {
            if(card) {
                setAccountName(card["account_name"]);
                setAccountNumber(card["account_number"]);
                setBankId(card["bank_id"]);
            }
        })();
    }, [card]);

    return (
        <>
            <Badge color="primary" className={"mb-2"}>Penarikan</Badge>
            {loading ? <AtomPageLoader/> : info ?
            <>
                <Form>
                    <FormGroup row>
                        <Label sm='3' for='account_name'>
                            Nama
                        </Label>
                        <Col sm='9'>
                            <InputGroup className='input-group-merge'>
                                <InputGroupAddon addonType='prepend'>
                                    <InputGroupText>
                                        <User size={15} />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input value={accountName ? accountName : ""} onChange={(e) => setAccountName(e.target.value)}
                                       type='text' name='account_name' id='account_name' placeholder='Nama Penerima Rekening' />
                            </InputGroup>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm='3' for='bank_id'>Bank</Label>
                        <Col sm='9'>
                            <Select
                                className='react-select'
                                classNamePrefix='select'
                                defaultValue={bankOptions[
                                    bankOptions.findIndex(data => data.value === bankId) === -1 ? 0 :
                                        bankOptions.findIndex(data => data.value === bankId)]}
                                options={bankOptions}
                                isClearable={false}
                                name={"bank_id"}
                                onChange={(e) => setBankId(e.value)}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm='3' for='account_number'>
                            Nomor Rekening
                        </Label>
                        <Col sm='9'>
                            <InputGroup className='input-group-merge'>
                                <InputGroupAddon addonType='prepend'>
                                    <InputGroupText>
                                        <CreditCard size={15} />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input value={accountNumber ? accountNumber : ""} onChange={(e) => setAccountNumber(e.target.value)}
                                        type='NUMBER' name='account_number' id='account_number' placeholder='Nomor Rekening' />
                            </InputGroup>
                        </Col>
                    </FormGroup>

                    <FormGroup className='mb-2' row>
                        <Col className={"text-right"}>
                            <Button color={"info"} outline onClick={() => {
                                dispatch(saveMyCardInfo({
                                    bank_id:bankId,
                                    account_number:accountNumber,
                                    account_name:accountName
                                }))
                            }}>Simpan Informasi Kartu</Button>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm='3' for='account_name'>
                            <span className={"text-danger"}>*</span> Nomer HP yang terdaftar
                        </Label>
                        <Col sm='9'>
                            <InputGroup className='input-group-merge'>
                                <InputGroupAddon addonType='prepend'>
                                    <InputGroupText>
                                        <User size={15} />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input value={phoneNumber ? phoneNumber : ""} onChange={(e) => setPhoneNumber(e.target.value)}
                                       type='text' name='phone_number' id='phone_number' placeholder='Nomer HP yang terdaftar' />
                            </InputGroup>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm='3' for='amount'>
                            Nominal Penarikan
                        </Label>
                        <Col sm='9'>
                            <InputGroup className='input-group-merge'>
                                <InputGroupAddon addonType='prepend'>
                                    <InputGroupText>
                                        <DollarSign size={15} />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input maxLength={10} value={withdrawalAmount} onChange={(e) => setWithdrawalAmount(e.target.value)}
                                        type='number' name='amount' id='amount' placeholder='Nominal Penarikan' />
                            </InputGroup>
                        </Col>
                    </FormGroup>

                    <FormGroup className='mb-0' row>
                        <Col className={"text-right"}>
                            <Button color={"primary"} onClick={() => {
                                dispatch(requestWithdraws({
                                    bank_id:bankId,
                                    account_number:accountNumber,
                                    account_name:accountName,
                                    amount:withdrawalAmount,
                                    phone_number:phoneNumber,
                                    type:"BANK"
                                }))
                            }}>Penarikan</Button>
                        </Col>
                    </FormGroup>

                    <br/>
                    <p className={"font-italic"}>
                        <span className={"text-danger"}>*</span> Digunakan untuk verifikasi
                    </p>
                </Form>
            </> : <AtomReferralGenerate/>
            }
        </>
    )
}

export default Withdrawal